import React from 'react'
import TasksHelper from '../../support/TasksHelper.js'

class TimelineItemSummary extends React.Component{
   render() {
    if (TasksHelper._countTaskItems(this.props.show_hidden_tasks, this.props.timeline_events.uncompleted_items, this.props.timeline_events.completed_items, this.props.show_essential_tasks, this.props.show_recommended_tasks, this.props.show_information_only_tasks) > 0) {
       return (
          <div className='timeline-item-summary'>
            <span className='task-icon' />
            <span className='timeline-item-count'>
              {
                TasksHelper._countTaskItems(this.props.show_hidden_tasks, this.props.timeline_events.uncompleted_items, this.props.timeline_events.completed_items, this.props.show_essential_tasks, this.props.show_recommended_tasks, this.props.show_information_only_tasks)
              }
            </span>
          </div>
        )
    } else {
      return (
        <div className='timeline-item-summary'/>
      )
    }
  }
}

export default TimelineItemSummary
